import * as Factory from 'factory.ts'
import faker from 'faker'

import { type Expense } from '@webapp/models'
import { DepartmentMock } from './department.factory'

export const ExpenseMock = Factory.Sync.makeFactory<Expense>({
  id: Factory.each(() => faker.random.number()),
  uuid: Factory.each(() => faker.random.uuid()),
  department: DepartmentMock.build(),
  total_amount: faker.random.number(),
})
